export default __webpack_public_path__ + "static/media/Opsti Uslovi.31417250.pdf";